import React, { useState, useEffect, useRef } from 'react';
import { useGlobalSearch } from '../../hooks/useGlobalSearch';
import { DocumentTextIcon } from "@heroicons/react/outline";

import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";
import Main_tabs_demo from "../modules/tabsdemo/Main_tabs_demo";
import Modal_started from "../Home/Modal_started";
import useDocumentTitle from "../../useDocumentTitle";
import { allArticulos } from '../../data';

const Help_center_test = () => {
    const [isOpen, setIsOpen] = useState(false);

    useDocumentTitle("SOPORTE | INVU POS ");
    const history = useHistory();
  
    const { t, i18n } = useTranslation();
    const [language, setLenguage] = useState("es");
  
    const onChangeLanguaje = () => {
      i18n.changeLanguage(language);
      if (language === "es") {
        setLenguage("en");
      } else {
        setLenguage("es");
      }
    };

      useEffect(() => {
    window.open("https://soporte.invupos.com/es-LA/support/home", "_blank");
  }, []);
  
    const location = useLocation();
    const prefix = useLocalePrefix();

    const containerRef = useRef(null);
  
    useEffect(() => {
      const container = containerRef.current;
      let scrollLeft = 0;
      let animationId;
  
      function animateScroll() {
        scrollLeft += 1; 
  
        if (scrollLeft >= container.scrollWidth - container.clientWidth) {
          clearInterval(animationId);
          setTimeout(() => { 
            scrollLeft = 0;
            animationId = setInterval(animateScroll, 1000 / 60);
          }, 2000);
        }
  
        container.scrollLeft = scrollLeft;
      }
  
      setTimeout(() => {
        animationId = setInterval(animateScroll, 1000 / 60); // Iniciar la animación
      }, 2000); 
   
      return () => clearInterval(animationId); 
    }, []); 

    const [height, setHeight] = useState('1000px');
  const isMobile = window.innerWidth <= 768; 

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 640) {
        setHeight('350px'); // Móviles pequeños
      } else if (width <= 768) {
        setHeight('600px'); // Tabletas en orientación vertical
      } else if (width <= 1024) {
        setHeight('650px'); // Tabletas en orientación horizontal y laptops pequeñas
      } else if (width <= 1280) {
        setHeight('800px'); // Laptops medianas y monitores pequeños
      } else {
        setHeight('750px'); // Monitores grandes y resoluciones mayores
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial value

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { query, setQuery, resultados } = useGlobalSearch();  


  // Después de useGlobalSearch y antes del return:
    const ultimas = allArticulos
    // 1. Filtramos sólo los que tengan fecha (si hay algunos sin fecha)
    .filter(a => a.fecha)
    // 2. Ordenamos descendente por fecha
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    // 3. Tomamos las 3 primeras
    .slice(0, 4);
  return (
    <>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />} 

    <section className="bg-white px-6 py-16 md:px-12 lg:px-20 lg:py-24 relative overflow-visible">
  {/* Contenido principal */}
  <div className="max-w-screen-xl mx-auto grid items-center gap-12 lg:grid-cols-2 md:px-24 lg:px-8">
    
    {/* Texto */}
    <div>
      <h2 className="text-blue-600 font-bold uppercase text-lg mb-2">Centro de ayuda</h2>
      <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6">
        Soporte Técnico <br /> de Invu POS
      </h1>
      <p className="text-gray-600 text-xl max-w-[540px]">
        Encuentra aquí manuales, demos y guías paso a paso para que tu experiencia con Invu POS sea siempre fluida, rápida y sin complicaciones.
      </p>
    </div>

    {/* Imagen */}
    <div className="w-full">
      <img
        src="https://img.invupos.com/webinvu/Help_center_test/cover_soporte_cwlfmc.webp"
        alt="Invu POS en uso"
        className="rounded-[2rem] w-full h-auto object-cover"
      />
    </div>
  </div>

  {/* Buscador flotante */}
  <div className="relative z-10 lg:-mt-10 md:-mt-4 mt-12">
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 max-w-screen-md mx-auto">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">¿Cómo podemos ayudarle?</h3>
      <form
            onSubmit={e => e.preventDefault()}
            className="flex flex-col md:flex-row items-stretch gap-4 relative"
          >
              <input
                type="text"
                placeholder="Cuéntanos tu problema..."
                value={query}
                onChange={e => setQuery(e.target.value)}
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {query && resultados.length > 0 && (
                <ul className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-b-2xl shadow-lg max-h-60 overflow-auto mt-1 z-20">
                  {resultados.map(item => (
                    <li
                      key={`${item.producto}-${item.id}`}
                      className="px-4 py-2 hover:bg-gray-100 flex items-center gap-2"
                    >
                      <DocumentTextIcon className="h-5 w-5 text-blue-500" />
                      <Link 
                      onClick={() => window.scrollTo(0, 0)}
                        to={item.enlace} 
                        className="flex-1 text-gray-800">
                        {item.titulo}
                      </Link>
                      <span className="text-xs text-gray-400">{item.producto}</span>
                    </li>
                  ))}
                </ul>
              )}
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition h-full flex items-center justify-center"
            >
              🔍 Buscar
            </button>
          </form>
    </div>
  </div>
</section>


<div className="mb-16 mt-12 px-6 mx-auto text-left sm:max-w-xl md:max-w-full lg:max-w-screen-xl">
            <div className="px-4 py-16 mx-auto md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-16  
            bg-[#d3e4f7] rounded-t-2xl overflow-hidden 
            bg-[url('https://img.invupos.com/webinvu/Help_center_test/Pattern_v2_cl1wil.png')] 
            bg-no-repeat bg-cover bg-center">
            
          <div className="flex flex-col gap-6 lg:gap-x-12 items-start justify-between px-6 rounded-lg md:flex-row ">
                {/* Título grande */}
                <div className="text-3xl font-bold leading-tight md:text-4xl">
                    <p className="">Soluciones Rápidas</p>
                    <p className="">y Sencillas</p>
                </div>

                {/* Texto intermedio */}
                <div className="text-base text-black md:text-lg md:ml-6">
                    <p>Soporte técnico para tu negocio sin demoras <br/> atención el mismo día</p>
                </div>

                {/* Botón */}
                <div className="md:ml-auto">
                    <a href="https://soporte.invupos.com/es-LA/support/tickets/new" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white font-medium px-6 py-3 rounded-lg hover:bg-blue-700 transition">
                    Enviar un ticket
                    </a>
                </div>
                </div>
      </div>
      <div className="relative px-10 sm:px-0">
        <div className="absolute inset-0 bg-[#d3e4f7] h-1/2 mx-auto lg:max-w-screen-xl sm:max-w-xl md:max-w-full rounded-b-2xl" />
        <div className="relative grid mx-auto overflow-hidden bg-white divide-y rounded-2xl shadow sm:divide-y-0 sm:divide-x sm:max-w-screen-sm sm:grid-cols-6 lg:max-w-screen-xl">
        <Link
        onClick={() => {
          localStorage.setItem('selectedManualProduct', 'panel_admin');
          window.scrollTo(0, 0);
        }}
        to="/manuales-de-centro-de-ayuda"
        className="inline-block p-8 text-center"
      >
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-indigo-50">
          <img src="https://img.invupos.com/webinvu/Help_center_test/Administrador_monnim.png" alt="Icono" />
        </div>
        <p className="font-bold text-gray-800">Administrador</p>
        <p className="text-sm text-gray-700 mt-3">Deja todo en nuestras manos. Gestionamos tu operación y te apoyamos en todo momento.</p>
      </Link>

      <Link
        onClick={() => {
          localStorage.setItem('selectedManualProduct', 'invu_pos');
          window.scrollTo(0, 0);
        }}
        to="/manuales-de-centro-de-ayuda"
        className="inline-block p-8 text-center"
      >
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-indigo-50">
          <img src="https://img.invupos.com/webinvu/Help_center_test/icon3_ysccbd.png" alt="Icono" />
        </div>
        <p className="font-bold text-gray-800">Aplicación Invu POS</p>
        <p className="text-sm text-gray-700 mt-3">Cumple con la normativa de tu país y factura de forma rápida y segura.</p>
      </Link>

      <Link
        onClick={() => {
          localStorage.setItem('selectedManualProduct', 'guias_clau');
          window.scrollTo(0, 0);
        }}
        to="/manuales-de-centro-de-ayuda"
        className="inline-block p-8 text-center"
      >
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-indigo-50">
          <img src="https://img.invupos.com/webinvu/Help_center_test/clau-guias_lekhw5.png" alt="Icono" />
        </div>
        <p className="font-bold text-gray-800">Guías Clau.io</p>
        <p className="text-sm text-gray-700 mt-3">¿Dudas sobre tu tienda online? Nuestro equipo te guía paso a paso.</p>
      </Link>

      <Link
        onClick={() => {
          localStorage.setItem('selectedManualProduct', 'integraciones_manuales');
          window.scrollTo(0, 0);
        }}
        to="/manuales-de-centro-de-ayuda"
        className="inline-block p-8 text-center"
      >
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-indigo-50">
          <img src="https://img.invupos.com/webinvu/Help_center_test/Integrations_rpxagk.png" alt="Icono" />
        </div>
        <p className="font-bold text-gray-800">Integraciones</p>
        <p className="text-sm text-gray-700 mt-3">Conectamos tu sistema con deliverys, bancos, e-commerce y más, sin complicaciones.</p>
      </Link>

      <Link
        onClick={() => {
          localStorage.setItem('selectedManualProduct', 'facturacion_electronica');
          window.scrollTo(0, 0);
        }}
        to="/manuales-de-centro-de-ayuda"
        className="inline-block p-8 text-center"
      >
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-indigo-50">
          <img src="https://img.invupos.com/webinvu/Help_center_test/facturacion_electronica_za4szu.png" alt="Icono" />
        </div>
        <p className="font-bold text-gray-800">Facturación Electrónica</p>
        <p className="text-sm text-gray-700 mt-3">Cumple con la normativa de tu país y factura de forma rápida y segura.</p>
      </Link>

      <Link
        onClick={() => {
          localStorage.setItem('selectedManualProduct', 'release_notes');
          window.scrollTo(0, 0);
        }}
        to="/manuales-de-centro-de-ayuda"
        className="inline-block p-8 text-center"
      >
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 rounded-full bg-indigo-50">
          <img src="https://img.invupos.com/webinvu/Help_center_test/releasenotes_qy4cov.png" alt="Icono" />
        </div>
        <p className="font-bold text-gray-800">Release Notes</p>
        <p className="text-sm text-gray-700 mt-3">Descubre las últimas novedades de Invu POS en un solo lugar.</p>
      </Link>
        </div>
      </div>
    </div>


      <h2 class="mt-20 max-w-5xl px-4 bg-white mb-4 font-sans text-3xl text-center font-semibold leading-none tracking-tight text-gray-900 sm:text-[60px] md:mx-auto">
        {/* {t("spprototypetitle")}  */}
        Soporte de Invu POS con Demo
      </h2>
      <p className='text-gray-600 text-center mt-3 text-lg max-w-2xl mx-auto'>{t("spprototypedescription")}</p>

      <iframe
        src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2Fm2SxDJKgzkr9K5UCoTn4Ya%2FPrototype-system-Invu%3Fnode-id%3D533-309%26node-type%3DCANVAS%26t%3DtOnevvtQivOeGHGX-1%26content-scaling%3Dfixed%26page-id%3D533%253A308&hide-ui=1"
        // src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2Fm2SxDJKgzkr9K5UCoTn4Ya%2FPrototype-system-Invu%3Fnode-id%3D533-309%26node-type%3DCANVAS%26t%3DtOnevvtQivOeGHGX-1%26scaling%3Dscale-down%26content-scaling%3Dfixed%26page-id%3D533%253A308&hide-ui=1"
        allowFullScreen
        style={{
          width: '100%',
          height: height,
          // margin: isMobile ? '0px' : '0', 
          // padding: isMobile ? '12px' : '0', 
          border: 'none',
        }}
      />


<div className="mt-8 px-4 py-0 mx-auto text-left sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 ">
        <div className="max-w-xl mb-4 sm:text-left lg:max-w-5xl md:mb-12">
          <h2 className="max-w-5xl mb-6 font-sans text-3xl font-semibold leading-none tracking-tight text-gray-900 sm:text-[40px] md:mx-auto">
          {t("sptabstitle")}
          </h2>
          <p className='text-gray-500 text-xl'>
         {t("sptabsdescription")}
          </p>
        </div>
      </div>
      <Main_tabs_demo/>

      <section className="px-6 py-16 bg-white -mt-20">
  <div className="max-w-screen-xl mx-auto grid gap-10 lg:grid-cols-5">
    
    {/* Columna izquierda: 60% */}
    <div className="bg-gray-100 rounded-3xl p-8 lg:col-span-3">
      <h2 className="text-3xl font-bold text-blue-600 mb-6">
        Ultimas Actualizaciones De Guias
      </h2>

      <div className="space-y-4">
        {ultimas.map(a => (
          <Link
            key={a.id}
            to={a.enlace}
            onClick={() => window.scrollTo(0, 0)}
            className="flex items-start bg-white rounded-2xl p-4 shadow-sm justify-between"
          >
            <div className="flex items-center gap-4">
              <DocumentTextIcon className="w-12 h-12 text-blue-600" />
              <div>
                <h3 className="font-bold text-gray-900 text-lg">
                  {a.titulo}
                </h3>
                <p className="text-sm text-gray-500">
                  {a.producto} / {a.subcategoria}
                </p>
              </div>
            </div>
            <p className="text-xs text-gray-400">
              {a.fecha}
            </p>
          </Link>
        ))}
      </div>

    </div>

    {/* Columna derecha: 40% */}
    <div className="bg-gray-100 rounded-3xl flex flex-col justify-between text-center h-full lg:col-span-2">
  {/* Título */}
  <div className="px-8 py-5">
    <h2 className="text-2xl font-bold text-gray-900">
      Incrementa tus ventas<br />
      <span className="text-blue-600">con LOYALTY</span>
    </h2>
    <div className="md:ml-auto mt-4">
      <Link
        onClick={() => window.scrollTo(0, 0)} to="/productos/programa-de-lealtad" 
        className="inline-block bg-blue-600 text-white font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition"
      >
        Descubre más
      </Link>
    </div>
  </div>

  {/* Imagen fija al fondo */}
  <div className="w-full max-w-xs mx-auto mb-0">
    <img
      src="https://img.invupos.com/webinvu/Help_center_test/Cover_punchcards_v2_oxsmhx.png"
      alt="Phones"
      className="w-full h-auto object-contain"
    />
  </div>
</div>
  </div>
</section>


</>
  );
};

export default Help_center_test;
